import React, { useEffect, useState } from "react";
import TooltipButton from "../../../components/Tooltip";
import mail from "../../../images/mail.svg";
import whatsapp from "../../../images/whatsapp.svg";
import "./UnReviewedOrders.css";
import { connect } from "react-redux";
import * as actions from "../actions";
import { opdbGTM } from "../../../utils/pulseUtils";

const OrderRow = ({ row, index, unReviewedList, sendNotification }) => {
  const [notificationMsg, setNotificationMsg] = useState({});
  const [callStatus, setCallStatus] = useState({});

  useEffect(() => {
    let notification = {
      whatsapp:
        row.whatsapp_reminder_count > 0 || row.email_reminder_count > 0
          ? "You can only send 1 reminder per user"
          : "Send a whatsapp msg with link for review to user",
      email:
        row.email_reminder_count > 0 || row.whatsapp_reminder_count > 0
          ? "You can only send 1 reminder per user"
          : "Send an email with link for review to user",
      isDisabled: row.whatsapp_reminder_count > 0 || row.email_reminder_count > 0,
    };

    setNotificationMsg(notification);

    setCallStatus({
      called: row.is_operator_called_to_user,
      notCalled: !row.is_operator_called_to_user,
    });
  }, [row]);

  const handleSendNotification = async (type, orderId, tripId) => {
    let query = {
      order_id: orderId,
      trip_id: tripId,
    };

    if (type === "whatsapp") {
      query.notification_channel = type;
      opdbGTM.askReviewWhatsapp();
    } else if (type === "email") {
      query.notification_channel = type;
      opdbGTM.askReviewEmail();
    } else if (type === "not-called" || type === "called") {
      query.is_operator_called_to_user = type === "called";
    }
    try {
      const notificationStatus = await sendNotification(query, { type });

      if (type === "whatsapp" || type === "email") {
        let notification = {
          whatsapp: "Send a whatsapp msg with link for review to user",
          email: "Send an email with link for review to user",
          isDisabled: false,
        };
        notification.whatsapp = notificationStatus
          ? "You can only send 1 reminder per user"
          : "Send a whatsapp msg with link for review to user";

        notification.email = notificationStatus
          ? "You can only send 1 reminder per user"
          : "Send an email with link for review to user";
        notification.isDisabled = notificationStatus;
        setNotificationMsg(notification);
      } else if (type === "not-called" || type === "called") {
        setCallStatus({
          notCalled: type === "not-called" ? notificationStatus : false,
          called: type === "called" ? notificationStatus : false,
        });
      }
    } catch (error) {
      console.error("Error triggering notification:", error);
    }
  };

  return (
    <tr
      key={index}
      style={{
        borderBottom: index === unReviewedList.length - 1 ? "1px solid #ddd" : "none",
      }}
    >
      <td>{row.user_name}</td>
      <td>{row.pnr}</td>
      <td>
        {row.source_city} - {row.destination_city}
      </td>
      <td>{row.doj}</td>
      <td>{row.mobile_no}</td>
      <td>
        <div class="calledStatus">
          <label>
            <input
              type="checkbox"
              checked={callStatus.notCalled}
              onClick={() => {
                handleSendNotification("not-called", row.order_id, row.paytm_trip_id);
              }}
            />
            Not Called
          </label>
          <label>
            <input
              type="checkbox"
              checked={callStatus.called}
              onClick={() => {
                handleSendNotification("called", row.order_id, row.paytm_trip_id);
              }}
            />
            Called
          </label>
        </div>
      </td>
      <td className="actions" style={{ border: "none" }}>
        <div className="button-wrapper" style={{ position: "relative" }}>
          <TooltipButton
            isDisabled={notificationMsg.isDisabled}
            isTooltipVisible={false}
            buttonTitle="Whatsapp"
            message={notificationMsg.whatsapp}
            srcImg={whatsapp}
            onClick={() => {
              !notificationMsg.isDisabled &&
                handleSendNotification("whatsapp", row.order_id, row.paytm_trip_id);
            }}
          />
        </div>
        <TooltipButton
          isDisabled={notificationMsg.isDisabled}
          isTooltipVisible={false}
          buttonTitle="Email"
          message={notificationMsg.email}
          srcImg={mail}
          onClick={() =>
            !notificationMsg.isDisabled &&
            handleSendNotification("email", row.order_id, row.paytm_trip_id)
          }
        />
      </td>
    </tr>
  );
};

const mapStateToProps = (store) => ({
  unReviewedList: store.ratingsReducer.unReviewedList,
  totalUnReviewedList: store.ratingsReducer.totalUnReviewedList,
});

const mapDispatchToProps = (dispatch) => ({
  sendNotification: (query, isNewQuery) => dispatch(actions.sendNotification(query, isNewQuery)),
});

OrderRow.propTypes = {};

export default connect(mapStateToProps, mapDispatchToProps)(OrderRow);